interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [
  { name: 'GlobalPayments', src: 'https://js.globalpay.com/5.1.3/globalpayments.js' },
];
